import React from 'react';

function RevisionHxPrint({ allData, template }) {
  return (
    <table style={{ width: '734px' }}>
      <tbody>
        <tr>
          <td style={{ width: '734px' }}>
            <table
              style={{ width: '734px', fontSize: '14px', marginBottom: '20px' }}
              cellSpacing="0"
              cellPadding="0"
              border="0"
            >
              <tbody>
                <tr>
                  <td
                    align="center"
                    style={{ fontSize: '21px', color: '#000', width: '734px' }}
                  >
                    {allData?.visitType}
                  </td>
                </tr>
              </tbody>
            </table>

            <table
              style={{ width: '734px', paddingBottom: '10px' }}
              cellSpacing="0"
              cellPadding="0"
              border="0"
              align="center"
            >
              <tbody>
                <tr>
                  <td
                    style={{ paddingTop: '10px', width: '407px' }}
                    valign="top"
                  >
                    <table
                      style={{ width: '407px' }}
                      cellSpacing="0"
                      cellPadding="0"
                      border="0"
                      align="left"
                    >
                      <tr>
                        <td>
                          {allData?.progressNoteData &&
                            allData?.progressNoteData.length > 0 &&
                            allData?.progressNoteData?.map(
                              (noteData, index) =>
                                noteData.preferred_label.toLowerCase() ===
                                  'demographics' && (
                                  <span
                                    key={index}
                                    dangerouslySetInnerHTML={{
                                      __html: noteData?.section_value, // Inject the printContent HTML as raw HTML
                                    }}
                                  />
                                )
                            )}
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td
                    style={{ paddingTop: '10px', width: '327px' }}
                    valign="top"
                  >
                    <table
                      style={{ width: '327px' }}
                      cellSpacing="0"
                      cellPadding="0"
                      border="0"
                    >
                      <tr>
                        <td
                          style={{
                            paddingTop: '20px',
                            fontSize: '13px',
                            width: '120px',
                          }}
                        >
                          <b>Provider:</b>
                        </td>
                        <td
                          style={{
                            paddingTop: '20px',
                            fontSize: '13px',
                            width: '207px',
                          }}
                        >
                          {allData?.counsellorName}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            paddingTop: '7px',
                            fontSize: '13px',
                            width: '120px',
                          }}
                        >
                          <b>Supervisor:</b>
                        </td>
                        <td
                          style={{
                            paddingTop: '7px',
                            fontSize: '13px',
                            width: '207px',
                          }}
                        >
                          {allData?.providerName}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            paddingTop: '7px',
                            fontSize: '13px',
                            width: '120px',
                          }}
                        >
                          <b>Date of service:</b>
                        </td>
                        <td
                          style={{
                            paddingTop: '7px',
                            fontSize: '13px',
                            width: '207px',
                          }}
                        >
                          {allData?.result_set?.dateOfVisit}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            paddingTop: '7px',
                            fontSize: '13px',
                            width: '120px',
                          }}
                        >
                          <b>Type of visit:</b>
                        </td>
                        <td
                          style={{
                            paddingTop: '7px',
                            fontSize: '13px',
                            width: '207px',
                          }}
                        >
                          {allData?.result_set?.typeOfVisit}
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>

            {allData?.progressNoteData &&
              allData?.progressNoteData.length > 0 &&
              allData?.progressNoteData?.map(
                (noteData, index) =>
                  noteData.preferred_label.toLowerCase() !== 'demographics' && (
                    <table
                      key={index}
                      style={{
                        marginTop: '15px',
                        paddingBottom: '10px',
                        width: '734px',
                      }}
                      cellSpacing="0"
                      cellPadding="0"
                      border="0"
                    >
                      <thead>
                        <tr>
                          <th
                            style={{
                              fontSize: '17px',
                              color: '#000',
                              width: '734px',
                            }}
                            align="left"
                          >
                            {noteData?.preferred_label}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td
                            style={{
                              fontSize: '13px',
                              color: '#000',
                              paddingTop: '5px',
                              lineHeight: '21px',
                              width: '734px',
                            }}
                          >
                            {/* {noteData?.section_value} */}
                            <div
                              dangerouslySetInnerHTML={{
                                __html: noteData?.section_value, // Inject the printContent HTML as raw HTML
                              }}
                            />

                            <span />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  )
              )}

            {/* {msgReqData && (
              <table
                style={{
                  marginTop: '0px',
                  paddingBottom: '10px',
                  width: '734px',
                }}
                cellSpacing="0"
                cellPadding="0"
                border="0"
              >
                <thead>
                  <tr>
                    <th
                      style={{
                        fontSize: '13px',
                        color: '#000',
                        width: '734px',
                      }}
                      align="left"
                    />
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td
                      style={{
                        fontSize: '13px',
                        color: '#000',
                        paddingTop: '5px',
                        lineHeight: '21px',
                        fontStyle: 'italic',
                        width: '719px',
                      }}
                    >
                      <span
                        style={{
                          fontSize: '14px',
                          color: '#000',
                          display: 'block',
                          marginLeft: '15px',
                        }}
                      >
                        Post-Enounter Messages:
                        {msgReqData.map((reqData, index) => (
                          <div key={index}>
                            <span
                              style={{
                                fontSize: '13px',
                                float: 'left',
                                width: '100%',
                                color: '#444',
                                marginLeft: '15px',
                              }}
                            >
                              {reqData.message}
                            </span>
                            <span
                              style={{
                                fontSize: '12px',
                                color: '#888',
                                marginBottom: '20px',
                                marginLeft: '15px',
                                float: 'left',
                                width: '100%',
                              }}
                            >
                              Added By:{' '}
                              {utilities.getProviderNamebyProviderId(
                                reqData.added_by
                              )}{' '}
                              -{' '}
                              {utilities.showDateForSpecificTimeZone(
                                reqData.request_date
                              )}
                            </span>
                          </div>
                        ))}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            )} */}

            {/* Add other sections like alertData, quikNoteData, nursingNote similarly */}

            {allData?.coSignerStr && (
              <table
                style={{
                  marginTop: '0px',
                  paddingBottom: '10px',
                  width: '734px',
                }}
                cellSpacing="0"
                cellPadding="0"
                border="0"
              >
                <thead>
                  <tr>
                    <th
                      style={{
                        fontSize: '13px',
                        color: '#000',
                        width: '734px',
                      }}
                      align="left"
                    />
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td
                      style={{
                        fontSize: '13px',
                        color: '#000',
                        paddingTop: '5px',
                        lineHeight: '21px',
                        fontStyle: 'italic',
                        width: '719px',
                      }}
                    >
                      {allData?.coSignerStr}
                    </td>
                  </tr>
                </tbody>
              </table>
            )}

            {allData?.rejectStr && (
              <table
                style={{
                  marginTop: '0px',
                  paddingBottom: '10px',
                  width: '734px',
                }}
                cellSpacing="0"
                cellPadding="0"
                border="0"
              >
                <thead>
                  <tr>
                    <th
                      style={{
                        fontSize: '13px',
                        color: '#000',
                        width: '734px',
                      }}
                      align="left"
                    />
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td
                      style={{
                        fontSize: '13px',
                        color: '#000',
                        paddingTop: '5px',
                        lineHeight: '21px',
                        fontStyle: 'italic',
                        width: '719px',
                      }}
                    >
                      {allData?.rejectStr}
                    </td>
                  </tr>
                </tbody>
              </table>
            )}

            {allData?.addendumList && allData?.addendumList?.length > 0 && (
              <table
                style={{
                  marginTop: '0px',
                  paddingBottom: '10px',
                  width: '734px',
                }}
                cellSpacing="0"
                cellPadding="0"
                border="0"
              >
                <thead>
                  <tr>
                    <th
                      style={{
                        fontSize: '13px',
                        color: '#000',
                        width: '734px',
                      }}
                      align="left"
                    >
                      Addendums
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {allData?.addendumList.map((addendum, index) => (
                    <tr key={index}>
                      <td
                        style={{ paddingLeft: '9px', whiteSpace: 'pre-line' }}
                      >
                        <p style={{ marginLeft: '9px' }}>
                          Provider Name & Credentials:{' '}
                          {addendum?.ProviderDetail} <br />
                          Original Note Date: {addendum?.originalNote} <br />
                          Addendum Date: {addendum?.addendumDate} <br />
                          Added By: {addendum?.addedBy} <br />
                          Reason for Addendum:
                          <br />
                          <span
                            dangerouslySetInnerHTML={{
                              __html: addendum?.reason,
                            }}
                          />{' '}
                          <br />
                          Additional Information:
                          <br />
                          <span
                            dangerouslySetInnerHTML={{
                              __html: addendum?.description,
                            }}
                          />
                        </p>
                        <br />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </td>
        </tr>
      </tbody>
    </table>
  );
}

export default RevisionHxPrint;
